import {
  adminPharmacistRatings,
  adminRatingDetails,
  adminRatingItems,
  getAdminPharmacistRating,
  getAdminProfessionalRatingItems,
  getPharmacistDetails,
  getRatingDetails,
  IRatingQuestions,
  pharmacistDetails,
  TypeOfUser,
} from '@pharmaplan/common';
import { useAppSelector } from '../../useAppSelector';
import strings from '../../../localization';

type IQuestions = Array<Omit<IRatingQuestions, 'professionalRatingQuestionId'>>;

const useAdminRatings = (userType: TypeOfUser) => {
  const details = useAppSelector(adminPharmacistRatings);
  const ratingData = useAppSelector(adminRatingItems);
  const detailedRating = useAppSelector(adminRatingDetails);
  const userDetails = useAppSelector(pharmacistDetails);

  const professionalLabels = {
    [TypeOfUser.pharmacist]: { title: strings.pharmacistRating, backTo: strings.pharmacistList },
    [TypeOfUser.technician]: { title: strings.technicianRating, backTo: strings.techniciansList },
    [TypeOfUser.student]: { title: strings.pharmacyStudentRating, backTo: strings.pharmacyStudentsList },
  };

  const { backTo, title } = professionalLabels?.[userType as keyof typeof professionalLabels] ?? {};

  const { pharmacistRatingItems } = ratingData ?? {};
  return {
    userRatingItems: pharmacistRatingItems,
    ratingData,
    propertyId: 'pharmacistRatingItemId',
    itemId: 'pharmactRatingId',
    details,
    nameProperty: 'pharmacyName',
    ratingDetailsAPI: getRatingDetails,
    userDetailsAPI: getPharmacistDetails,
    ratingAPI: getAdminPharmacistRating,
    ratingItemAPI: getAdminProfessionalRatingItems,
    questions: [] as IQuestions,
    questionId: '',
    detailedRating,
    user: userDetails.pharmacist,
    codeProperty: 'pharmacyCode',
    backTo,
    title,
  };
};

export default useAdminRatings;
